var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetterC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.86 80V68.57H11.43V57.14H0V22.86h11.43V11.43h11.43V0h45.71v11.43H80v11.43H57.14V11.43H34.29v11.43H22.86v34.28h11.43v11.43h22.85V57.14H80v11.43H68.57V80z",
    fill: "#e8ffa2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDgwIDgwIj4KICA8cGF0aCBkPSJNMjIuODYsODBWNjguNTdIMTEuNDNWNTcuMTRIMFYyMi44NkgxMS40M1YxMS40M0gyMi44NlYwSDY4LjU3VjExLjQzSDgwVjIyLjg2SDU3LjE0VjExLjQzSDM0LjI5VjIyLjg2SDIyLjg2VjU3LjE0SDM0LjI5VjY4LjU3SDU3LjE0VjU3LjE0SDgwVjY4LjU3SDY4LjU3VjgwWiIgZmlsbD0iI2U4ZmZhMiIvPgo8L3N2Zz4K";
export { SvgLetterC as ReactComponent };